import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Icons from "assets";
import { SidebarMenu } from "components/partials/sidebar-menu";
import { useCurrentUser } from "hooks/api/use-current-user";
import { Permission } from "types/auth";
import { hasPermission } from "utilities/user";
import { AppSidebarNavigation } from "./app-sidebar-navigation";
import {
  ACCOUNT_ACTIONS,
  SIDEBAR_COLLAPSED_STORAGE_KEY,
  getAccountSubtitle,
} from "./app-sidebar.constants";

const AppSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(
    window.localStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === "true",
  );

  useEffect(() => {
    window.localStorage.setItem(SIDEBAR_COLLAPSED_STORAGE_KEY, String(isCollapsed));
  }, [isCollapsed]);

  const currentUser = useCurrentUser();
  const isClientUser = hasPermission(currentUser, Permission.PERM_CLIENT_USER);
  const accountName = [currentUser.firstName, currentUser.lastName].filter(Boolean).join(" ") || currentUser.email;

  return (
    <SidebarMenu isCollapsed={isCollapsed} onCollapsedChange={setIsCollapsed}>
      <SidebarMenu.Header
        logo={<Icons.ApolloLogo className="h-6 w-[148px] text-navy-800" aria-label="Apollo" />}
        collapsedLogo={
          <Icons.ApolloIcon className="h-[25px] w-[25px] text-navy-800" aria-label="Apollo" />
        }
      />

      <AppSidebarNavigation
        isClientUser={isClientUser}
        pathname={location.pathname}
        navigate={navigate}
        currentUser={currentUser}
      />

      <SidebarMenu.Account
        account={{
          name: accountName,
          role: getAccountSubtitle(currentUser, isClientUser),
        }}
        actions={ACCOUNT_ACTIONS}
      />
    </SidebarMenu>
  );
};

export default AppSidebar;
